<template>
    <div class="calltracking-setup-layout">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .calltracking-setup-layout {

    }
</style>

<script>
    import Card from '@/app/shared/components/Card'

    export default {
      components: {
        Card,
      }
    }
</script>
